"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
var _CButton = _interopRequireDefault(require("../materials/CButton"));
var _CDialog = _interopRequireDefault(require("../materials/CDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DialogContentStyled = (0, _styles.styled)(_DialogContent.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    padding: theme.spacing(2)
  };
});
const ButtonStyled = (0, _styles.styled)(_CButton.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    padding: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(1), "px")
  };
});
const MessageWrap = (0, _styles.styled)('div')(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1.4,
    '& .MuiTypography-root': {
      fontSize: 'inherit',
      lineHeight: 'inherit'
    },
    '& p, & ul, & ol, & li, & div': {
      fontSize: 'inherit',
      lineHeight: 'inherit'
    }
  };
});

/**
 * 確認ダイアログ
 * @prop {bool} open - 開閉フラグ
 * @prop {string} title - ダイアログタイトル
 * @prop {node} message - ダイアログ本文
 * @prop {func} [handleClose] - キャンセルボタン押下時イベント
 * @prop {func} [handleOk] - OKボタン押下時イベント
 *
 */
const ConfirmDialog = function (props) {
  const {
    open,
    title,
    message,
    handleClose,
    handleOk,
    width,
    intl
  } = props;
  const CustomPaper = width !== null ? 480 : 350;
  return /*#__PURE__*/_react.default.createElement(_CDialog.default, {
    maxWidth: false,
    PaperProps: {
      sx: {
        maxWidth: CustomPaper,
        margin: 'auto'
      }
    },
    open: open,
    title: title,
    handleClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(DialogContentStyled, {
    sx: {
      marginTop: 2
    }
  }, /*#__PURE__*/_react.default.createElement(MessageWrap, null, message)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, handleClose && /*#__PURE__*/_react.default.createElement(ButtonStyled, {
    negative: true,
    onClick: handleClose
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_CANCEL
  })), /*#__PURE__*/_react.default.createElement(ButtonStyled, {
    onClick: () => {
      handleOk();
      handleClose();
    }
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_OK
  }))));
};
ConfirmDialog.propTypes = {
  open: _propTypes.default.bool.isRequired,
  title: _propTypes.default.string.isRequired,
  message: _propTypes.default.node.isRequired,
  handleClose: _propTypes.default.func,
  handleOk: _propTypes.default.func.isRequired,
  width: _propTypes.default.string
};
var _default = exports.default = (0, _reactIntl.injectIntl)(ConfirmDialog);